/**
 * The bell's grouping of notification kinds (TZ §19): which family a kind belongs to, so the
 * bell can show a glyph for it. Unknown kinds fall back to "other", never to a blank.
 */

export type NotificationGroup =
  | "conversation"
  | "lead"
  | "task"
  | "finance"
  | "ai"
  | "channel"
  | "security"
  | "other";

const GROUP_BY_KIND: Record<string, NotificationGroup> = {
  free_queue_conversation: "conversation",
  conversation_new_message: "conversation",
  conversation_overdue: "conversation",
  sla_step_1: "conversation",
  sla_step_2: "conversation",
  sla_step_3: "conversation",
  sla_step_4: "conversation",
  instagram_window_closing: "conversation",
  negative_comment: "conversation",
  ai_answered_in_human_thread: "conversation",
  ai_handoff: "ai",
  phone_taken: "lead",
  lead_handed_without_phone: "lead",
  proposal_opened: "lead",
  proposal_variant_chosen: "lead",
  clients_auto_merged: "lead",
  duplicate_suspected: "lead",
  emergency_trip: "security",
  task_assigned: "task",
  reminder_due: "task",
  task_overdue: "task",
  frozen_deal_follow_up: "task",
  morning_briefing: "task",
  trip_1_2_days: "task",
  missing_document: "task",
  pre_trip_reminder: "task",
  payment_pending_approval: "finance",
  payment_approved: "finance",
  payment_rejected: "finance",
  online_payment_received: "finance",
  payment_link_expired: "finance",
  expected_payment_due: "finance",
  expected_payment_overdue: "finance",
  provider_payment_due: "finance",
  provider_payment_overdue: "finance",
  payment_storno: "finance",
  report_ready: "finance",
  balance_low: "finance",
  credits_exhausted: "finance",
  ai_draft_awaiting_approval: "ai",
  guardrail_stopped: "ai",
  prompt_injection_attempt: "security",
  ai_emergency_stop: "security",
  ai_day_job_failed: "ai",
  memory_rule_suggested: "ai",
  test_centre_blocked: "ai",
  autonomy_recommended: "ai",
  knowledge_expired: "ai",
  weekly_ai_quality_report: "ai",
  ai_daily_limit_reached: "ai",
  channel_disconnected: "channel",
  telegram_flood_wait: "channel",
  instagram_token_expiring: "channel",
  provider_login_failed: "channel",
  provider_down: "channel",
  canary_broken: "channel",
  support_session_started: "security",
  security_alert: "security",
  demo_request_received: "other",
  system: "other",
};

/** The family of a notification kind. Unknown kinds are "other" rather than an error. */
export function groupOf(kind: string): NotificationGroup {
  return GROUP_BY_KIND[kind] ?? "other";
}
